import SignUp from 'pages/AccountCenter/SignUp'
import { useEffect, useState } from 'react'
import ForgotPassword from './ForgotPassword'
import Login from './Login'
import FlutterAppData from 'services/flutterAppConnection'
export default function AccountCenter({ active = 'SignUp', handleClose }: { active?: string; handleClose?: Function }) {
  const [type, setType] = useState<string>(active)
  useEffect(() => {
    setType(active)
  }, [active])

  useEffect(() => {
    if (FlutterAppData.isInAppEnv() && (type === 'Login' || type === 'SignUp')) {
      FlutterAppData.evokeAppLogin()
      if (handleClose) {
        handleClose()
      }
    }
  }, [type, handleClose])

  return (
    <>
      <SignUp
        open={type === 'SignUp'}
        handleClose={(data: string) => {
          setType(data)
          if (data === 'close' && handleClose) {
            handleClose()
          }
        }}
      ></SignUp>
      <Login
        open={type === 'Login'}
        handleClose={(data: string) => {
          setType(data)
          if (data === 'close' && handleClose) {
            handleClose()
          }
        }}
      ></Login>
      <ForgotPassword
        open={type === 'Forgot'}
        handleClose={(data: string) => {
          setType(data)
          if (data === 'close' && handleClose) {
            handleClose()
          }
        }}
      ></ForgotPassword>
    </>
  )
}
